import { CommonModule } from '@angular/common';
import { Component, inject, signal, ChangeDetectionStrategy } from '@angular/core';
import { email, form, required, FormField } from '@angular/forms/signals';
import { RouterModule } from '@angular/router';
import { AuthApiService } from '@core/services/api/auth.service';

interface IMensajeFront {
  tipo: 'success' | 'error';
  titulo: string;
  mensaje: string;
}

@Component({
  selector: 'app-auth-recuperar-cuenta',
  imports: [RouterModule, FormField, CommonModule],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './recuperar-cuenta.html',
})
export class AuthRecuperarCuenta {
  private readonly authService = inject(AuthApiService);
  mensajeFront = signal<IMensajeFront | null>(null);
  mensajeEnviado = signal(false);

  form = form(
    signal({
      email: '',
      ruc: '',
    }),
    (schemaPath) => {
      required(schemaPath.ruc, { message: 'RUC is required' });
      required(schemaPath.email, { message: 'Email is required' });
      email(schemaPath.email, { message: 'Enter a valid email address' });
    },
  );

  onRecuperar(event: Event) {
    event.preventDefault();
    if (this.form().invalid()) {
      this.mensajeFront.set({
        tipo: 'error',
        titulo: 'Error',
        mensaje: 'Por favor, completa todos los campos correctamente.',
      });
      return;
    }
    this.mensajeFront.set(null);

    const { email, ruc } = this.form().value();
    this.authService.recuperar(email.trim(), ruc.trim()).subscribe({
      next: () => {
        this.mensajeFront.set({
          tipo: 'success',
          titulo: 'Revisa tu bandeja de entrada',
          mensaje:
            'Si el correo está registrado, recibirás un enlace para restablecer tu contraseña en unos minutos.',
        });
        this.mensajeEnviado.set(true);
      },
      error: (err) => {
        this.mensajeFront.set({
          tipo: 'error',
          titulo: 'Error al recuperar la cuenta',
          mensaje:
            err.error?.message ||
            'Ocurrió un error al intentar recuperar la cuenta. Por favor, intenta nuevamente.',
        });
      },
    });
  }
}
